if (!window.MobiFoldVideoReady) {
  window.MobiFoldVideoReady = true;

  const setupMobiFoldVideos = (root = document) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-mobi-fold-video]').forEach((video) => {
      if (video.dataset.mobiFoldReady === 'true') return;
      video.dataset.mobiFoldReady = 'true';
      if (reduceMotion) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) video.play().catch(() => {});
          else video.pause();
        });
      }, { threshold: 0.45 });
      observer.observe(video);
    });
  };

  document.addEventListener('DOMContentLoaded', () => setupMobiFoldVideos());
  document.addEventListener('shopify:section:load', (event) => setupMobiFoldVideos(event.target));
}
